import CommonUtil from "../../utils/CommonUtil"

const Privacy = props => {

    const callPhone = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage('400-069-0588')
        }
    }

    return <div style={{ marginLeft: 15, marginRight: 15 }}>
        <p><strong>隐私政策</strong></p>
        <p>&nbsp;</p>
        <p>发布时间：2024年09月06日</p>
        <p>生效时间：2024年09月06日</p>
        <p>&nbsp;</p>
        <p>本隐私政策规定了上海摩象网络科技有限公司北京分公司及关联公司（下文简称&ldquo;摩象科技&rdquo;或&ldquo;我们&rdquo;）如何收集、使用、披露、处理和保护您在使用Mology Cam产品和服务时提供给我们的信息；<strong><strong>若我们要求您提供某些信息，以便在使用Mology Cam产品和服务时验证您的身份，我们将仅严格遵守本隐私政策和/或我们的用户条款与条件来使用这些信息。</strong></strong></p>
        <p>&nbsp;</p>
        <p>本隐私政策在制定时充分考虑到您的需求，请通过本文全面了解摩象科技的个人资料收集方式和使用惯例，并且确信自己最终能控制提供给摩象科技的个人信息。在这项隐私政策中，&ldquo;个人信息&rdquo;是指以电子方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
        <p>&nbsp;</p>
        <p>请您审慎阅读并选择接受或不接受本隐私政策，有关您个人信息权益的条款等重要内容我们已用加粗形式提示，请您特别关注。如您未满18周岁，请您在监护人陪同下仔细阅读并充分理解本隐私政策，并征得监护人的同意后使用我们的服务或向我们提供信息。</p>
        <p>&nbsp;</p>
        <p>通过使用Mology Cam产品和服务，即表示您已阅读、认可并接受本隐私政策中所述之所有条款，包括我们随时作出的任何变更。</p>
        <p>最后，我们所希望的就是为我们的用户带来最好的体验。如果您对这一隐私政策中概括的数据处理惯例有任何疑问，请通过官网联系我们的数据保护官，以便我们处理您的特殊需求。</p>
        <p>&nbsp;</p>
        <p>一、我们如何收集和使用您的个人信息</p>
        <p>二、我们如何使用Cookie和同类技术</p>
        <p>三、我们如何共享、转让、公开披露您的个人信息</p>
        <p>四、我们如何保护您的个人信息的安全</p>
        <p>五、您的权利</p>
        <p>六、我们如何处理未成年人的个人隐私</p>
        <p>七、我们如何存储您的个人信息</p>
        <p>八、《隐私权政策》的修订和通知</p>
        <p>九、适用范围</p>
        <p>十、优先顺序</p>
        <p>十一、开发者信息及联系方式</p>
        <p>&nbsp;</p>
        <p>一、我们如何收集和使用您的个人信息</p>
        <p>为了向您提供我们的服务，我们会要求您提供向您提供服务所必需的个人信息。如果您不提供个人信息，我们可能无法向您提供我们的产品或服务。</p>
        <p>为了更好地提供小默产品以及智能服务，我们或合作公司根据服务需要，在同意《隐私政策》之后且在法定范围内使用您主动提供的个人信息，请放心数据信息不会用于其他商业用途。</p>
        <p>我们将努力确保合作公司在使用您的个人信息时遵守本隐私条款，及我们要求其遵守的其他适当的保密和安全措施。</p>
        <p>&nbsp;</p>
        <p>1、帮助您注册Mology Cam账号</p>
        <p>1)&nbsp;在您使用本产品和服务时，我们需要您注册一个Mology Cam账号，以更加充分地使用本产品和服务的全部功能，我们会收集您的<strong><strong>手机号码</strong></strong>，用于您在用手机号注册登录&ldquo;Mology Cam&rdquo;时为您创建的账号并为您提供相关服务，如果您在注册账号时，不提供上述信息，您将无法完成注册并享受产品功能和或服务。</p>
        <p>2)&nbsp;在同意《隐私政策》之后，在登录和使用的过程中，我们会收集您上传的或拍摄的头像照片，用于为您创建&ldquo;Mology Cam&rdquo;的账号头像。</p>
        <p>3)&nbsp;因我们需要获取您是通过何种渠道下载我们的App，我们会通过友盟（第三方数据平台）统计应用获取您的邀请信息，在此过程中我们会获取您的MAC/IMEI/IMSI信息。</p>
        <p>&nbsp;</p>
        <p>2、 向您提供网络安全及运营安全保障</p>
        <p>1)&nbsp;为保障您的账号、网络、运营及系统安全，在您同意《隐私政策》后的使用过程中，我们可能会收集您的<strong><strong>设备相关信息</strong></strong>，如设备型号、加速度传感器数据、操作系统版本、软件版本号、设备配置、设备网络信息、网络状态、应用程序列表、 设备环境等软硬件特征信息，其中包括不可变更的设备唯一标识（如IMEI号、AndroidID、GUID、OPENUDID、ICCID）、硬件序列号、MAC地址、oaid，用于了解产品适配性、识别账号异常状态以及保证产品和服务相应功能的正常实现。</p>
        <p>2)&nbsp;维护产品安全及时排除故障。为维护我们服务的正常运行，以及保障您的帐号安全、排查产品故障、改进及优化我们的服务，我们会收集您的<strong><strong>登陆IP地址、服务日志</strong></strong>。这类信息是为提供服务必须收集的信息，用于识别账号异常状态及满足相关法律法规的要求，收集后即作去标识化处理，不会用于识别任何特定的用户。</p>
        <p>3)&nbsp;为帮助我们更好地了解&ldquo;Mology Cam&rdquo;及服务的运行情况，以便确保运行与提供服务的安全，我们可能记录网络日志信息，以及使用软件及相关服务的频率、崩溃数据、总体安装、使用情况、性能数据等。</p>
        <p>4)&nbsp;产品集成友盟+SDK及推送通道SDK（如小米、华为、oppo、vivo、魅族等），推送通道SDK需要收集采集设备标识符（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/ICCID/SIM 卡 IMSI 信息等），基于设备信息用于生成脱敏的终端用户设备标识，向设备完成消息推送服务。采集地理位置甄别推送通道，提高消息推送的区域覆盖率。</p>
        <p>&nbsp;</p>
        <p>3、提供Mology Cam产品的当前状态</p>
        <p>1)&nbsp;设备信息：我们会收集与您设备的硬件、性能、状态等相关的信息，包括设备名称、设备ID（DID）、固件版本号、设备时区；设备电量、存储卡信息（异常状态、剩余容量、录制模式）。</p>
        <p>2)&nbsp;设备设置信息：我们可能会收集与设备设置相关的信息，包括分辨率选择、白平衡偏好、静止延时设定、轨迹延时设定、录像/拍照模式选择、曝光参数、屏宽选择和美颜设定。</p>
        <p>&nbsp;</p>
        <p>4、我们可能需要向您获取的设备权限，以下权限均在同意《隐私政策》之后调用</p>
        <p>1)&nbsp;我们需要获取访问您的<strong><strong>手机相册、媒体库的授权</strong></strong>，用于图片或视频到您的相册，上传您的账号头像等；如您不使用我们提供的上述服务，则可不提供此项授权，您也可以随时取消对我们访问您的手机相册的授权。</p>
        <p>2)&nbsp;我们需要获取访问您的<strong><strong>手机录音权限的授权</strong></strong>，用于您使用&ldquo;Mology Cam&rdquo;的双向对讲功能，如您不使用我们提供的上述服务，则可不提供此项授权，您也可以随时取消对我们访问您的麦克风的授权。</p>
        <p>3)&nbsp;我们需要获取访问您的<strong><strong>手机存储的权限</strong></strong>，用于读写您的相册，获取已下载的图片、视频。该权限会在征得您的同意后开启，不会默认开启。</p>
        <p>4)&nbsp;我们需要获取访问您的<strong><strong>蓝牙和位置权限</strong></strong>，用于连接您的设备。该权限会在征得您的同意后开启，不会默认开启。</p>
        <p>5)&nbsp;我们需要收集获取 WiFi 的 SSID ，用于连接您的设备。</p>
        <p>&nbsp;</p>
        <p>5、App崩溃后会尝试自启动</p>
        <p>在使用的过程中，可能会出现 Mology Cam App和手机内存分配不匹配的情况，所以您偶尔会遇到App崩溃的现象，我们尽量会减少这种情况出现。当软件崩溃后会开始自启动，方便您下次使用的时候更快速的响应。</p>
        <p>&nbsp;</p>
        <p>6、收集、使用个人信息目的的变更和处理</p>
        <p><strong><strong>请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，并征得您的同意。</strong></strong></p>
        <p>&nbsp;</p>
        <p>7、依法豁免征得同意收集和使用的个人信息</p>
        <p>请您理解，在下列情形中，根据法律法规/或相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：</p>
        <p>1)&nbsp;与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公众知情等重大公共利益直接相关的；</p>
        <p>2)&nbsp;与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
        <p>3)&nbsp;为应对突发公共事件，或者紧急情况下为维护您或其他个人的生命、财产、声誉等重大合法权益所必须的；</p>
        <p>4)&nbsp;所收集的用户信息是您自行向社会公众公开的；</p>
        <p>5)&nbsp;从合法公开披露的信息中收集用户信息的，如合法的新闻报道、政府信息公开等渠道；</p>
        <p>6)&nbsp;根据您要求签订和履行合同所必需的；</p>
        <p>7)&nbsp;用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
        <p>8)&nbsp;为开展合法的新闻报道所必需的；</p>
        <p>9)&nbsp;出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的用户信息进行去标识化处理的；</p>
        <p>10)&nbsp;与我们履行法律法规规定的义务相关的；</p>
        <p>11)&nbsp;法律法规规定的其他情形。</p>
        <p>&nbsp;</p>
        <p>8、有关App自启动</p>
        <p>如果您在系统中开启了&ldquo;自启动&rdquo;功能。App不在前台的时，如收到云端推送将会自启动，保证您第一时间收到推送信息。如不需要此功能请在系统中关闭&ldquo;自启动&rdquo;。</p>
        <p>&nbsp;</p>
        <p>请您注意，如信息无法单独或结合其他信息识别到您的个人身份，其并不属于法律意义上您的个人信息，当您的信息可以单独或结合其他信息识别到您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，则在结合使用期间，这些信息将作为您的个人信息按照本《隐私权政策》处理与保护。</p>
        <p>&nbsp;</p>
        <p>9、为服务用户的目的，获得您的事先同意情况下，我们可能通过使用您的个人信息，APP为您提供更好的服务。关于我们如何使用您的信息（其中可能包含个人信息），下面提供了更多详细信息。</p>
        <p>1)&nbsp;与您就您的设备、服务或任何普通查询（例如更新、客户咨询支持、我们活动的相关信息、通知）等进行交流。</p>
        <p>2)&nbsp;分析和开发与我们产品及服务的使用相关的统计信息，以更好地改进我们的产品和服务。</p>
        <p>3)&nbsp;提供推送服务，Mology Cam账号也将用于提供推送服务，以发送软件更新的通知。</p>
        <p>&nbsp;</p>
        <p>二、我们如何使用Cookie</p>
        <p>Cookie和同类技术是互联网中的通用常用技术。当您使用 Mology Cam及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集和存储您访问、使用本产品时的信息，并用于以下目的：</p>
        <p>&nbsp;</p>
        <p>1、保障产品与服务的安全、高效运转</p>
        <p>我们可能会设置认证与保障安全性的&nbsp;Cookie&nbsp;或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。</p>
        <p>&nbsp;</p>
        <p>2、帮助您获得更轻松的访问体验</p>
        <p>使用此类技术可以帮助您省去重复填写个人信息、重复选择视频编辑功能步骤和流程。</p>
        <p>我们承诺，我们不会将使用Cookie和同类技术所收集的信息用于本隐私权政策所述目的之外的任何其他用途。</p>
        <p>&nbsp;</p>
        <p>3、Cookie的清除</p>
        <p>大多数浏览器均为用户提供了清除浏览器缓存数据的功能，你可以在浏览器设置功能中进行相应的数据清除操作。如你进行清除，你可能无法使用由我们提供的、依赖于Cookie的服务或相应功能。</p>
        <p>&nbsp;</p>
        <p>三、 我们如何共享、转让、公开披露您的个人信息。</p>
        <p><strong><strong>1、我们不会向其他任何公司、组织和个人分享您的个人信息，但以下情况除外：</strong></strong></p>
        <p>1)&nbsp;在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
        <p>2)&nbsp;我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</p>
        <p>3)&nbsp;与我们的关联公司共享：您的个人信息可能会与我们关联公司共享。我们只会共享必要的个人信息，且受本隐私权政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。</p>
        <p>&nbsp;</p>
        <p>2、<strong><strong>与授权合作伙伴共享：仅为实现本隐私权政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。</strong></strong>在这种情况下，这些公司必须遵守我们的数据隐私和安全要求。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。如果您不再希望允许我们共享这些信息，在收到授权申请时，请拒绝提供即可。</p>
        <p>为了使您能够接收信息推送、在第三方平台分享信息等必要的功能用途，&ldquo;Mology Cam&rdquo;软件中会嵌入授权合作伙伴的SDK或其他类似的应用程序。如您使用华为/小米/魅族手机时，华为/小米/魅族Push SDK需要读取您的设备识别号、联网相关信息，用于推送/下发通知栏消息；如您使用向微博、微信、QQ账号以及其他第三方平台分享信息功能，相关SDK会收集您的设备识别号、联网相关信息。</p>
        <p>&nbsp;</p>
        <p>3、对共享个人信息第三方主体的谨慎评估及责任约束</p>
        <p>1)&nbsp;经您同意，我们只会与第三方共享实现目的所必要的信息。如果第三方因业务需要，确需超出前述授权范围使用个人信息的，该第三方需再次征求你的自主选择同意。</p>
        <p>2)&nbsp;对我们与之共享你个人信息的第三方，该第三方会与我们签订保密协议。同时，我们会对其数据安全能力与环境进行评估并要求第三方以不低于本《隐私权政策》所要求的保密和安全措施来处理该信息。</p>
        <p><strong><strong>接入第三方SDK总览</strong></strong></p>
        <p>&nbsp;</p>
        <table>
            <tbody>
                <tr>
                    <td width="40">
                        <p>名称</p>
                    </td>
                    <td width="40">
                        <p>使用场景</p>
                    </td>
                    <td width="60">
                        <p>厂商</p>
                    </td>
                    <td width="40">
                        <p>SDK隐私权政策链接</p>
                    </td>
                </tr>
                <tr>
                    <td width="40">
                        <p>友盟推送</p>
                    </td>
                    <td width="40">
                        <p>信息推送</p>
                    </td>
                    <td width="40">
                        <p>北京锐讯灵通科技有限公司</p>
                    </td>
                    <td width="40">
                        <p><a href="https://www.umeng.com/page/policy">www.umeng.com</a></p>
                    </td>
                </tr>
                <tr>
                    <td width="40">
                        <p>涂鸦</p>
                    </td>
                    <td width="40">
                        <p>设备绑定，开流，事件上报等服务</p>
                    </td>
                    <td width="40">
                        <p>杭州涂鸦信息技术有限公司</p>
                    </td>
                    <td width="40">
                        <p><a href="https://auth.tuya.com/policies/privacy">tuya.com</a></p>
                    </td>
                </tr>
                <tr>
                    <td width="40">
                        <p>QQ分享</p>
                    </td>
                    <td width="40">
                        <p>用于用户主动发起的视频或链接分享</p>
                    </td>
                    <td width="40">
                        <p>腾讯科技（深圳）有限公司</p>
                        <p>&nbsp;</p>
                    </td>
                    <td width="40">
                        <p><a href="https://privacy.qq.com/">https://privacy.qq.com</a></p>
                    </td>
                </tr>
                <tr>
                    <td width="40">
                        <p>新浪微博分享</p>
                    </td>
                    <td width="40">
                        <p>用于用户主动发起的视频或链接分享</p>
                        <p>&nbsp;</p>
                    </td>
                    <td width="40">
                        <p>北京微梦创科网络技术有限公司</p>
                    </td>
                    <td width="40">
                        <p><a href="https://weibo.com/signup/v5/privacy">www.weibo.com</a></p>
                    </td>
                </tr>
                <tr>
                    <td width="40">
                        <p>微信分享</p>
                    </td>
                    <td width="40">
                        <p>用于用户主动发起的视频或链接分享</p>
                    </td>
                    <td width="40">
                        <p>腾讯科技（深圳）有限公司</p>
                    </td>
                    <td width="40">
                        <p><a href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                    </td>
                </tr>
                <tr>
                    <td width="40">
                        <p>抖音分享</p>
                    </td>
                    <td width="40">
                        <p>用于用户主动发起的视频或链接分享</p>
                        <p>&nbsp;</p>
                    </td>
                    <td width="40">
                        <p>北京字节跳动网络技术有限公司</p>
                    </td>
                    <td width="40">
                        <p><a href="https://www.oceanengine.com/extra/legal">www.oceanengine.com</a></p>
                    </td>
                </tr>
                <tr>
                    <td width="40">
                        <p>Bugly</p>
                    </td>
                    <td width="40">
                        <p>用于抓取崩溃日志，提升稳定性</p>
                        <p>&nbsp;</p>
                    </td>
                    <td width="40">
                        <p>深圳市腾讯计算机系统有限公司</p>
                    </td>
                    <td width="40">
                        <p><a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56">https://privacy.qq.com</a></p>
                    </td>
                </tr>
                <tr>
                    <td width="40">
                        <p>号码认证</p>
                    </td>
                    <td width="40">
                        <p>用于用户快速注册登录</p>
                        <p>&nbsp;</p>
                    </td>
                    <td width="40">
                        <p>阿里巴巴云计算（北京）有限公司</p>
                    </td>
                    <td width="40">
                        <p><a href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html?spm=a2c4g.11186623.0.0.727039eb0HflH4">https://terms.aliyun.com/legal-agreement</a></p>
                    </td>
                </tr>
            </tbody>
        </table>
        <p>&nbsp;</p>
        <p>4、转让</p>
        <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
        <p>1)&nbsp;在明确获得您的同意的前提下，我们会向其他方转让您的个人信息；</p>
        <p>2)&nbsp;随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，你的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所载明的安全标准要求继受方保护你的个人信息，否则我们将要求继受方重新征得你的授权同意。同时我们将提前告知您信息继承受方的名称及其处理个人信息的场景、目的、方式、种类、期限等。</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>5、公开披露</p>
        <p>我们仅会在以下情况下，收集或公开披露您的个人信息，我们公开披露你的个人信息会采用符合行业内标准的安全保护措施：</p>
        <p>1)&nbsp;获得您明确的同意后；</p>
        <p>2)&nbsp;基于法律法规、司法机关或行政主管部门的强制性要求，我们可能会披露您的个人信息。</p>
        <p>不经授权收集、共享、转让或公开披露个人信息的例外。</p>
        <p>&nbsp;</p>
        <p>根据相关法律法规的规定，在以下情形中，我们可以在不征得您的授权同意的情况下收集、共享、转让或公开披露您的个人信息。</p>
        <ol>
            <li>与国家安全、国防安全等国家利益直接相关的；</li>
            <li>与公共安全、公共卫生、公众知情等重大公共利益直接相关的；</li>
            <li>与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
            <li>出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；</li>
            <li>根据您要求签订和履行合同所必需的；</li>
            <li>用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</li>
            <li>出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</li>
            <li>从合法公开披露的信息中收集到的个人信息的，如合法的新闻报道、政府信息公开等渠道；</li>
            <li>法律法规规定的其他情形。</li>
        </ol>
        <p>&nbsp;</p>
        <p>四、我们如何保护您的个人信息</p>
        <p>1、我们非常重视你个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护你的个人信息，防止你提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄露。</p>
        <p>2、我们会使用不低于行业同行的加密技术、匿名化处理等合理可行的手段保护您的个人信息，并使用安全保护机制防止你的个人信息遭到恶意攻击。</p>
        <p>3、我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。</p>
        <p>4、我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们承诺将使您的个人信息存储时间始终处于法律要求或实现产品功能和服务所需的合理必要的期限内。对于超出期限的个人信息，我们会立即删除或做匿名化处理。</p>
        <p>5、尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证绝对的安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯设备，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的帐号密码及相关个人信息透露给他人等。</p>
        <p>6、在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
        <p>7、我们特别提醒您，本《隐私权政策》提供的个人信息保护措施仅适用于&ldquo;Mology Cam&rdquo;软件及相关服务。一旦您离开&ldquo;Mology Cam&rdquo;及相关服务，浏览或使用其他网站、服务及内容资源，我们没有能力及义务保护您在&ldquo;Mology Cam&rdquo;软件及相关服务之外的软件、网站提交的个人信息，无论您登录、浏览或使用上述软件、网站是否基于&ldquo;Mology Cam&rdquo;的链接或引导。</p>
        <p>&nbsp;</p>
        <p>五、您的权利</p>
        <p>1、您可以通过不向任何人（除非此人经您正式授权）披露您的登录密码或账户信息，为保护您个人信息的安全发挥作用。</p>
        <p>2、摩象科技不对因您未能保持个人信息的私密性而导致第三方访问您的个人信息进而造成的安全疏漏承担责任。尽管有上述规定，如果发生互联网其他任何用户未经授权使用您账户的情况或其他任何安全漏洞，您必须立即通知我们。</p>
        <p>3、您的协助将有助于我们保护您个人信息的私密性。</p>
        <p>4、如有必要实现收集信息的目的，或者遵守适用法律要求或允许，我们将一直保留个人信息。只要能够合理推断保留个人信息不能实现收集个人信息的目的，并且出于法律、解决纠纷、强制实施我们的协议或其他商业目的不再需要保留信息时，我们将不再保留个人信息，或者会消除将个人信息和特定个人关联起来的途径。</p>
        <p>5、我们的应用程序可能会访问您设备上的某些功能，例如Wi-Fi&nbsp;网络状态，以及其他功能。这些信息用于允许这些应用程序在您的设备上运行，并且允许您与其互动。<strong><strong>在任何时候，您可以通过在设备上关闭应用程序或者通过&nbsp;<a href="#" onClick={callPhone}>400-069-0588</a>&nbsp;致电联系我们来撤销许可。</strong></strong></p>
        <p>6、登入或登出Mology Cam账户。</p>
        <p>访问、更新或更正您的个人信息</p>
        <p>7、您有权要求访问和/或更正我们持有的与您有关的任何个人信息。当您更新个人信息时，在我们处理您的请求前，会要求验证您的身份。一旦我们获得充分信息，可处理您的请求以访问或更正您的个人信息时，我们将在适用数据保护法规定的时间内对您的请求做出回应。</p>
        <p>8、我们通常免费提供这些服务，但是保留对您的数据访问请求收取合理费用的权利。</p>
        <p>9、如果您希望请求访问我们持有的个人数据或者如果您认为我们持有的关于您的任何信息是不正确或不完整的，请尽快致电联系我们。</p>
        <p>10、与您Mology Cam账户中的个人信息相关的更多详细信息，您可以通过您的设备登入账户来访问和更改。</p>
        <p>11、<strong><strong>您可以通过提交诉求，撤销同意收集、使用和/或披露我们掌握或控制的您的个人信息。还可以通过致电我们表达相关诉求。</strong></strong>我们将会在您做出诉求后的30日内处理您的诉求，并且会根据您的诉求，在此后不再收集、使用和/或披露您的个人信息。</p>
        <p>请注意，您撤销同意会导致某些法律后果。根据您撤销同意让我们处理您的个人信息的范围，这可能表示您不能享受摩象科技的产品和服务。</p>
        <p>12、如果我们需要将个人信息转移到您所属的司法管辖区之外，无论是转移给我们的关联公司或第三方服务供应商时，我们将按照适用法律，对您进行充分告知，并获得您的授权后进行。我们通过落实合适的安全保障措施，保证所有这类转移满足适用的地方数据保护法的要求，并且不会改变我们对遵守本隐私权政策保护您的个人信息的所有承诺。</p>
        <p>13、<strong><strong>注销账号：您可以在Mology Cam App里我的-账号与安全路径下点击注销账号按钮，收到注销账户请求后，我们将在7天后删除或匿名化处理用户的个人信息。</strong></strong></p>
        <p>&nbsp;</p>
        <p>六、我们如何处理未成年人的个人隐私</p>
        <p>1、我们认为监督孩子使用我们的产品和服务是父母的责任。但是，我们的政策不要求获得未成年人的个人信息，或者向这类人群发送任何促销资料。</p>
        <p>2、摩象科技不会寻求或试图寻求接收来自未成年人的任何个人信息。如果家长或监护人有理由相信未成年人未经他们事先同意而向摩象科技提交了个人信息，请联系我们以确保删除此类个人信息，并保证未成年人取消订阅任何适用的摩象科技服务。</p>
        <p>3、若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本政策说明的方式与我们联系。</p>
        <p>&nbsp;</p>
        <p>七、我们如何存储您的个人信息</p>
        <p>1、存储地点：我们将遵守法律法规规定，在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。目前，我们不会将您的个人信息传输至中华人民共和国境外，如因业务拓展等原因需要向境外传输，我们将会遵循相关国家规定并取得您的同意。</p>
        <p>2、存储时间：我们仅在为提供Mology Cam App服务之目的所必需的期间内保留您的个人信息，在您未撤回、删除或未注销账号期间，我们会保留相关信息。<strong><strong>超出必要期限或您撤回授权、删除、注销账号后，我们将在7天后删除或匿名化处理用户的个人信息。</strong></strong></p>
        <p>&nbsp;</p>
        <p>八、《隐私权政策》的修订和通知</p>
        <p>我们会对隐私政策进行定期审核，为反映我们信息惯例的变更，我们可能会更新本隐私政策。如果我们对本隐私政策进行重大变更，我们将通过（向您账户指定的邮箱地址发送）电子邮件或在所有摩象科技网站公布或通过移动设备通知您，这样您可以了解我们收集的信息以及我们如何使用这些信息。此类隐私政策变化将从通知或网站规定的生效日期开始适用。我们建议您定期查阅本网页获取我们隐私权实践的最新信息。您继续使用产品和网站、手机和/或其他任何设备上的服务，将被视为接受更新的隐私政策。在我们向您收集更多的个人信息或我们希望因为新的目的使用或披露您的个人信息时，我们会再次征得您的同意。</p>
        <p>&nbsp;</p>
        <p>九、适用范围</p>
        <p>我们的隐私政策不适用于第三方提供的产品和服务。摩象科技产品和服务可能包括第三方的产品和服务，以及第三方网站的链接。当您使用这些产品或服务时，也可能收集您的信息。因此，我们强烈建议您花时间阅读该第三方的隐私政策，就像阅读我们的政策一样。我们不对第三方如何使用他们向您收集的个人信息负责，也不能控制其使用。我们的隐私政策不适用通过我们的服务链接的其他网站。</p>
        <p>&nbsp;</p>
        <p>十、优先顺序</p>
        <p><strong><strong>如果您同意了适用的用户协议，并且此类用户协议和本隐私政策之间存在不一致，将以此类用户协议为准。</strong></strong></p>
        <p>&nbsp;</p>
        <p>十一、开发者信息及联系方式</p>
        <p>软件开发者：上海摩象网络科技有限公司北京分公司</p>
        <p>电话：<a href="#" onClick={callPhone}>400-069-0588</a></p>
        <p>联系地址：上海漕河泾开发区松江高科技园莘砖公路668号202室-28</p>
        <p>&nbsp;</p>
    </div>
}

export default Privacy